import React from "react"

import type { MetricRecordData } from "@/types/metrics/contracts"
import type { RunMetricOutput } from "@/types/RunMetricOutput"

import { appendAgentJudgeEvidence } from "../agent-judge/agentJudgeEvidence"
import {
  AgentJudgeCategoricalConfiguration,
  AgentJudgeMetadataEditor,
  AgentJudgeReadOnlyMetadata,
} from "../agent-judge/AgentJudgeMetadataEditor"
import { CategoricalLLMMetricRecord } from "./CategoricalLLMMetricRecord"

export class AgentJudgeCategoricalMetricRecord extends CategoricalLLMMetricRecord {
  getCategoricalOptions(): string[] {
    return (this.metric_metadata?.categories ?? []).filter(
      (category) => category.trim().length > 0,
    )
  }

  protected getHumanFeedbackCategoricalOptions(): string[] {
    return this.getCategoricalOptions()
  }

  renderReadOnlyMetadata(metricRecordData: MetricRecordData): React.ReactNode {
    const categories = metricRecordData.metric_metadata?.categories ?? []

    return (
      <AgentJudgeReadOnlyMetadata
        metricRecordData={metricRecordData}
        outputConfiguration={
          <div>
            <p className="text-sm font-medium text-coval-text">Categories</p>
            <p className="text-sm text-coval-text">
              {categories.length > 0 ? categories.join(", ") : "None"}
            </p>
          </div>
        }
      >
        {super.renderReadOnlyMetadata(metricRecordData)}
      </AgentJudgeReadOnlyMetadata>
    )
  }

  renderEditorMetadata(
    metricRecordData: MetricRecordData,
    onChange: (metric: MetricRecordData) => void,
  ): React.ReactNode {
    return (
      <AgentJudgeMetadataEditor
        metricRecordData={metricRecordData}
        onChange={onChange}
        questionPlaceholder={
          "Enter a question that classifies the conversation into one of your categories.\n\nThe Agent Judge investigates only through the enabled read-only tools and returns the most appropriate configured category."
        }
        outputConfiguration={
          <AgentJudgeCategoricalConfiguration
            metricRecordData={metricRecordData}
            onChange={onChange}
          />
        }
      />
    )
  }

  getDeepDiveSections(
    metricOutput: RunMetricOutput,
  ): { label: string; content: React.ReactNode }[] | null {
    return appendAgentJudgeEvidence(
      super.getDeepDiveSections(metricOutput),
      metricOutput,
    )
  }
}
